import auditLocationEnum from '../constants/auditLocationEnum'

export const conditionColors = (condition) => {
  switch (condition) {
    case '4':
    case '3':
      return 'text-fpx-red'
    case '2':
      return 'text-yellow'
    default:
      return 'text-grey-100'
  }
}

export const isMaxRefloored = (auditUnit) => {
  if (auditUnit?.attributes['maximum-refloors'] == null) return false
  return auditUnit?.attributes['current-floor'] >= auditUnit?.attributes['maximum-refloors'] + 1
}

export const canRefloor = (condition, auditUnit) => {
  if (isMaxRefloored(auditUnit)) {
    return '0'
  }

  switch (condition) {
    case '4':
    case '3':
      return '0'
    case '1':
      return '1'
    default:
      return auditUnit.attributes['can-refloor'] ? '1' : '0'
  }
}

export const getAuditUnitWarnings = (auditUnit) => {
  const warnings = []
  if (!auditUnit) return warnings

  const currentSold = auditUnit.attributes['current-sold'] ?? auditUnit.attributes.sold

  if (isMaxRefloored(auditUnit)) {
    warnings.push('MAX REFLOORS')
  } else if (!auditUnit.attributes['can-refloor']) {
    warnings.push('NO REFLOOR')
  }

  if (auditUnit.attributes['is-nsf']) {
    warnings.push('NSF')
  }
  if (auditUnit.attributes['is-repo']) {
    warnings.push('REPO')
  }
  if (auditUnit.attributes['sot-on']) {
    warnings.push('SOT')
  }

  switch (currentSold) {
    case 1:
      warnings.push('SOLD')
      break
    case 3:
      warnings.push('TEST DRIVE')
      break
    case 4:
      warnings.push('ARB')
      break
  }

  return warnings
}

// Location: 1 = On the Lot, 2 = Not On the Lot, 3 = At Auction
// Condition: 1 = Touched Frontline Ready, 2 = Touched Not Frontline Ready,
//            3 = Touched Non Compliant Unit, 4 = Not Touched
export const getDefaultLocation = (auditData) => {
  const currentLocation = String(auditData?.current_location)
  if (Object.keys(auditLocationEnum).includes(currentLocation) && isLocationSelectable(currentLocation, auditData?.condition)) {
    return currentLocation
  }

  return String(auditData?.condition) === '4' ? '2' : '1' // Not Touched means Not On the Lot
}

export const isOnTheLot = (currentLocation) => String(currentLocation) === '1'

export const isLocationSelectable = (location, condition) =>
  !(isOnTheLot(location) && String(condition) === '4') // Not Touched units cannot be On the Lot

export const getConditionFromAuditUnit = (auditUnit) => {
  if (!auditUnit) return null

  if (!auditUnit.attributes['compliant']) {
    return '3'
  } else if (Number(auditUnit.attributes['rating']) === 4) {
    return '4'
  } else if (Number(auditUnit.attributes['rating']) === 3) {
    // If the unit is compliant and 3C, condition is Touched Not Frontline Ready
    return '2'
  } else if (Number(auditUnit.attributes['rating']) === 1) {
    return '1'
  }

  return null
}